function contents() {

	return {
		'click_to_activate_demo'    : 'CLICK TO ACTIVATE DEMO ACCOUNT',
		'click_to_activate_telegram': 'CLICK TO ACTIVATE TELEGRAM ACCOUNT'
	};

}

export default contents;